import React, {Component} from 'react';
import './styles/FileViewer.css';

export default class FileViewer extends Component{

    constructor(props) {
        super(props);

        let isImage = false;
        let isImageLoading = false;


        if( props.name ) {
            const extension = props.name.split(".").splice(-1, 1);
            if( extension.length ) {
                isImage = inlineImgExtensions.indexOf(extension[0].toLowerCase()) !== -1;
                isImageLoading = isImage;
            }
        }

        this.state = {
            isImage,
            isImageLoading
        };
    }

    render() {
        return (
            <div className={"FileViewer" + (this.state.isImageLoading ? " imageLoading" : "")}>
                {this.state.isImage ?
                    <img src={this.props.src}
                         alt="File"
                         onLoad={() => {
                             this.setState({isImageLoading:false})
                         }}
                    /> :
                    <iframe src={this.props.src} title={this.props.name ? this.props.name : Math.random()}/>
                }
            </div>
        );
    }
}

const inlineImgExtensions = ["png","jpg","jpeg","bmp","gif"];


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/FileViewer/index.js